<template>
  <div class="hnsports_result" v-if="itemDetail">
    <div class="go-back">
      <van-button @click="goBack" size="small" :color="buttonColor"><van-icon name="arrow-left" /> 返回</van-button>
    </div>
    <div class="header">
      <div class="avatar">
        <img :src="itemDetail.user.avatarurl" />
      </div>
      <div class="info">
        <div class="nickname">
          {{ itemDetail.user.name||itemDetail.user.nickname }}
        </div>
        <div class="rank">
          <span>{{ itemDetail.voted || 0 }}</span>
          <span>点赞数</span>
        </div>
        <div class="rank">
          <span>{{ itemDetail.distance || '-' }}</span>
          <span>本周里程(km)</span>
        </div>
      </div>
    </div>

    <div class="body">
      <div  v-for="(item,key) in mylist" :key="key"  class="myitem">
        <van-tag class="tag" :type="item.class" size="medium">{{ item.statename }}</van-tag>
        <van-image width="2.92rem" height="2.17rem" :src="item.mediaurl[0]"/>
        <div class="item-cell" style="padding-top: .13rem">
          <div>上传时间：</div>
          <div>{{item.statetime}}</div>
        </div>
        <div class="item-cell">
          <div>今日里程：</div>
          <div>{{item.score}} km</div>
        </div>
        <div class="mvbutton btn" @click="openImg(item.mediaurl[0])">查看大图</div>
      </div>
    </div>
<!--    <div class="footer btn-area">-->
<!--      <van-button round plain color="#FFAA81" @click="show = true">分 享</van-button>-->
<!--      <van-button round plain @click="vote" color="#FFAA81">投 票</van-button>-->
<!--    </div>-->
    <van-overlay z-index="1000" :show="show" @click="show = false">
      <div class="wrapper">
        <img style="width:100%" src="../../../assets/img/common/share.png" />
      </div>
    </van-overlay>
  </div>
  <Empty v-else description="数据加载中" />
</template>

<script>
import mVideo from '@/components/mVideo/index'
import { mapGetters } from 'vuex'
import moment from "moment";
import Footbar from '@/components/footbar/index'
import { Empty, Panel, Cell, Button, CellGroup, Image, Popup, Overlay, Tag } from 'vant'

export default {
  computed: {
    buttonColor() {
      let detail = this.detail
      if (!detail) return '#ccc'
      return `${detail.tabstyle[0]['color']}`
    },
    ...mapGetters({
      u: 'getUserInfo',
    }),
  },
  components: {
    Footbar,
    Empty,
    Panel,
    Cell,
    Button,
    CellGroup,
    VanImage: Image,
    VanOverlay: Overlay,
    mVideo,
    Popup,
    VanTag:Tag
  },
  props: ['item_sub_id', 'sports_id'],
  data() {
    return {
      show: false,
      detail: '',
      itemDetail: '',
      myDetail: {},
      joinList: [],
      certShow: false,
      mylist: []
    }
  },
  methods: {
    goBack() {
      this.$router.back(-1)
    },
    openImg(url) {
      // ...
      wx.previewImage({
        current: '', // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      })
    },
    vote() {
      this.$api.sports
          .vote({
            mcloud_sports_item_user_id: this.$route.query.uid,
          })
          .then((r) => {
            this.init()
          })
    },
    init: function() {
      this.$toast.loading({
        duration: 0,
      })
      let params = { cpgid: this.item_sub_id,uid:this.$route.query.id }
      Promise.all([this.$api.sports.sportsMain(this.sports_id), this.$api.bainian.getUser(params),this.$api.sports.getComparegame(params)])
          .then((res) => {
            let { bgstyle, id, tabstyle, introstyle, title } = res[0].data
            try {
              bgstyle = JSON.parse(bgstyle)
              tabstyle = JSON.parse(tabstyle)
              introstyle = JSON.parse(introstyle)
            } catch (e) {
              console.error(e)
            }
            this.detail = { id, bgstyle, tabstyle, introstyle, title }
            // this.joinList = res[1]['list'];
            let list = res[1]['data'].list
            list.forEach((item)=>{
              item.statetime = moment(item.create_time*1000).format('MM月DD日')
              item.mediaurl = JSON.parse(item.mediaurl)
              if(item.state==1){
                item.statename = '审核通过'
                item.class = 'success'
              }else if(item.state==0){
                item.statename = '待审核'
                item.class = 'warning'
              }else{
                item.statename = '审核不通过'
                item.class = 'danger'
              }
            })
            this.mylist = list
            this.myDetail = res[2]['data']
            this.itemDetail = res[1]['data']
            this.$toast.clear()
          })
          .then(() => {
            const shareConf = {
              title: ` 我正在参加“嘉定区建党100周年主题健康跑”。动动手指，请帮我投一票吧！`,
              path: '/pages/webview/index?src=' + encodeURIComponent(window.location.href),
            }

            wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) })
          })
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="less" scoped>
.hnsports_result {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #D33836;
  .go-back {
    width: 100%;
    padding: 0.3rem;
    font-size: 0;
    box-sizing: border-box;
  }
  .wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    img {
      width: 100%;
      position: absolute;
      top: 0rem;
    }
  }
  > .header {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 6.9rem;
    margin: 0.12rem auto 0.24rem;
    background-image: linear-gradient(180deg, #FFE7D9 0%, #FFA073 100%);
    box-shadow: 0 .02rem .04rem 0 #8D100E, inset 0 .02rem .01rem 0 #FFFFFF;
    border-radius: .12rem;
    padding: 0.24rem 0.4rem;
    > .avatar {
      width: 1.14rem;
      height: 1.14rem;
      box-sizing: border-box;
      border-radius: 50%;
      border: .03rem solid #FFEEE5;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.26rem;
      > img {
        overflow: hidden;
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    > .info {
      width: 4.7rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > .nickname {
        font-size: 0.28rem;
        color: rgba(151,65,30,0.85);
        letter-spacing: 0;
      }
      .rank {
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: .25rem;
        color: rgba(151,65,30,0.85);
        letter-spacing: 0;
        span:first-of-type {
          font-size: .4rem;
          font-weight: bold;
          color: rgba(151,65,30,0.85);
          letter-spacing: 0;
        }
      }
    }
  }
  > .body {
    margin-top: .46rem;
    width: 6.9rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .myitem{
      background: #ffffff;
      margin-bottom: .3rem;
      box-sizing: border-box;
      padding: .22rem .2rem .17rem;
      box-shadow: 0 .06rem .2rem 0 rgba(24,127,200,0.40);
      border-radius: .12rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      font-size: .28rem;
      color: rgba(0,0,0,0.45);
      letter-spacing: 0;
      position: relative;
      .tag{
        position: absolute;
        right: .05rem;
        top: .05rem;
        z-index: 100;
      }
      .item-cell{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: .4rem;
        padding-bottom: .09rem;
        >div:nth-child(2){
          color: rgba(0,0,0,0.85);
        }
      }
      .btn{
        background-image: linear-gradient(180deg, #FFE2D2 0%, #FFAA81 100%);
        box-shadow: 0 .02rem .04rem 0 #DAA779, inset 0 .03rem .03rem 0 #FFE2CA;
        border-radius: .305rem;
        width: 2.05rem;
        height: .51rem;
        line-height: .51rem;
        font-size: .24rem;
        color: #7C4310;
        letter-spacing: 0;
      }
    }
  }
  .footer{
    display:flex;
    align-items:center;
    width: 6.9rem;
    padding:0.5rem;
    justify-content: center;
    .van-button {
      width: 48%;
      height: 0.64rem;
      line-height: 0.6rem;
    }
  }
}
</style>
